// test1161
(1161 && 0);
